import React from 'react';
import {FormGroup, Label, CustomInput} from 'reactstrap';

import {useFieldState, ErrorTooltip} from '@/Form/index';

const Select = ({id, name, label, children, ...rest}) => {
  const fieldState = useFieldState({id, name});
  const {id: target, errors} = fieldState;

  return (
    <FormGroup>
      <Label htmlFor={target}>{label}</Label>
      <CustomInput type='select' {...fieldState} {...rest}>
        {children}
      </CustomInput>
      <ErrorTooltip errors={errors} target={target} />
    </FormGroup>
  );
};

export default Select;
